



























<template>
  <v-layout>
    <v-flex>
      <v-container grid-list-lg>
        <v-layout
          row
          wrap
        >
          <v-flex
            xs6
            sm4
            md3
            lg2
            v-for="meat in typesOfMeat"
            :key="meat.name"
          >

            <v-card
              class="grey darken-4"
              hover
            >
              <v-img :src="meat.src">
              </v-img>
              <v-card-actions>
                <v-container fluid>
                  {{meat.name}}
                  <v-switch v-model="meat.value"></v-switch>
                  <v-layout
                    v-if="meat.value && meat.choices"
                    row
                    wrap
                  >
                    {{meat.choiceQuestion}}

                    <v-radio-group
                      v-model="meat.choiceSelected"
                      row
                    >
                      <v-radio
                        class="box"
                        v-for="choice in meat.choices"
                        :key="choice.id"
                        :label="choice.name"
                        :value="choice.id"
                      >
                      </v-radio>
                    </v-radio-group>
                    <h4 v-if="meat.choiceSelected == 'halfRibSteakHalfPrimeRib'">
                      {{meat.choices[1].choiceQuestion}}
                    </h4>
                    <h4 v-if="meat.choiceSelected == 'halfRibSteakHalfPrimeRib'">
                      <v-radio-group v-model="meat.choices[1].choiceSelected">
                        <v-radio
                          v-for="ch in meat.choices[1].choices"
                          :key="ch.id"
                          :label="ch.name"
                          :value="ch.id"
                        >
                        </v-radio>
                      </v-radio-group>
                    </h4>
                  </v-layout>
                </v-container>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapMultiRowFields } from 'vuex-map-fields'
export default {
 name: 'beefGallery',
 data: () => ({
  selection: '',
 }),
 computed: {
  ...mapMultiRowFields('data', ['form.typesOfMeat']),
 },
}
</script>

<style scoped>
.white--text {
 color: black !important;
}
.box {
 margin: 3.25%;
}
</style>
